import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  isLoggedIn: false,
  data: {
    nepToken: null,
    uuaToken: null
  }
};

export const slice = createSlice({
  name: 'authentication',
  initialState,
  reducers: {
    setInitialState: (state) => {
      state.isLoggedIn = initialState.isLoggedIn;
      state.data = initialState.data;
    },
    setLoggedIn: (state) => {
      state.isLoggedIn = true;
    },
    setLoggedOut: (state) => {
      state.isLoggedIn = false;
    },
    setData: (state, { payload }) => {
      state.data = payload;
    }
  }
});

export const {
  setInitialState,
  setLoggedIn,
  setLoggedOut,
  setData
} = slice.actions;

export const selectSlice = (state) => state[slice.name];
export const selectIsLoggedIn = (state) => selectSlice(state).isLoggedIn;
export const selectData = (state) => selectSlice(state).data;
export const selectNepToken = (state) => selectData(state).nepToken;
export const selectUuaToken = (state) => selectData(state).uuaToken;

export default slice.reducer;
